import moment from "moment";
import {DOCUMENT_TYPE} from "utils/constants";
import type {MyTask} from "types/myTasks";

const DATED_TYPES: readonly number[] = Object.freeze([DOCUMENT_TYPE.LEAVE_REQUEST, DOCUMENT_TYPE.TIMESHEET]);

/**
 * The period a leave request or timesheet covers, as short as it can be said: "May 1. - 31.",
 * "Apr 1. - May 2.", or with years once it spans two of them. Empty for any other task.
 */
export function taskPeriod(task: MyTask): string {
    if (!task || !DATED_TYPES.includes(task.documentType as number)) return '';
    if (task.fromDate == null || task.toDate == null) return '';

    const from = moment(task.fromDate);
    const to = moment(task.toDate);
    if (!from.isValid() || !to.isValid()) return '';

    if (from.year() !== to.year()) return from.format("YYYY MMM D.") + " - " + to.format("YYYY MMM D.");
    if (from.month() !== to.month()) return from.format("MMM D.") + " - " + to.format("MMM D.");
    return from.format("MMM D.") + " - " + to.format("D.");
}

/**
 * The description as the list shows it: prefixed with the period, so several leave periods of one
 * employee can be told apart without opening them.
 */
export function taskDescription(task: MyTask): string {
    const description = task?.description ?? '';
    const period = taskPeriod(task);
    return period ? "(" + period + ") " + description : description;
}
